module.exports = __webpack_public_path__ + "images/banners/pasodash/top_7de65a21b78bc2d4794cc777363f7851.png";